import React from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  LICENSE_SERVICE_STATUS_ACTIVE,
  LICENSE_SERVICE_STATUS_INACTIVE,
  ORG_SERVICE_STATUS_PRO_KEY,
  UNITY_PRO_SERVICE_KEY,
} from "const/license";

const SubscriptionsStatusBlock = ({ data }) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={4}>
        {/* Org-Level Status - Hidden for now, supported in future */}
        {/*
        <Stack spacing={2}>
          <Typography
            sx={{
              color: "#172664",
              fontSize: "15px",
              fontWeight: "bold",
            }}
          >
            Org-Level Services Status
          </Typography>
          <Box sx={{ pl: 0 }}>
            <Stack direction='column' spacing={1} sx={{ width: "fit-content" }}>
              <Typography
                variant='caption'
                sx={{ color: "rgba(0,0,0,0.45)", fontSize: "12px" }}
              >
                AI Chatbot
              </Typography>
              <StatusTag
                status={data.org.aiChatbotEnabled}
                statusMapping={{
                  green: ["true"],
                  grey: ["false"],
                }}
                labelMapping={{
                  true: "Active",
                  false: "Inactive",
                }}
              />
            </Stack>
          </Box>
        </Stack>
        */}

        {/* Site-Level Status */}
        <Stack spacing={2}>
          <TableContainer
            component={Box}
            sx={{ border: "none", boxShadow: "none" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      color: "#172664",
                      fontWeight: "bold",
                      fontSize: "14px",
                      pb: 2,
                      pl: 0,
                    }}
                  >
                    Site
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      color: "#172664",
                      fontWeight: "bold",
                      fontSize: "14px",
                      pb: 2,
                      textAlign: "center",
                    }}
                  >
                    Devices
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      color: "#172664",
                      fontWeight: "bold",
                      fontSize: "14px",
                      pb: 2,
                      pr: 0,
                    }}
                  >
                    Nuclias Unity Pro
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(data?.org?.sites || []).map((site, index) => {
                  const devices =
                    (Number(site.accessPoints) || 0) +
                    (Number(site.switches) || 0);
                  const isProActive =
                    (site.services?.[UNITY_PRO_SERVICE_KEY] ??
                      site.services?.[ORG_SERVICE_STATUS_PRO_KEY]) === true;

                  return (
                    <TableRow
                      key={site.id}
                      sx={{
                        bgcolor: index % 2 === 1 ? "#F9F9F9" : "transparent",
                        "& .MuiTableCell-root": { border: "none", py: 1.5 },
                      }}
                    >
                      <TableCell sx={{ color: "rgba(0,0,0,0.65)", pl: 0 }}>
                        {site.name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "rgba(0,0,0,0.65)", textAlign: "center" }}
                      >
                        {devices}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: isProActive
                            ? "rgba(0,0,0,0.87)"
                            : "rgba(0,0,0,0.65)",
                          fontWeight: isProActive ? "bold" : "normal",
                          pr: 0,
                        }}
                      >
                        {isProActive
                          ? LICENSE_SERVICE_STATUS_ACTIVE
                          : LICENSE_SERVICE_STATUS_INACTIVE}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Stack>
    </Box>
  );
};

export default SubscriptionsStatusBlock;
